/**
 * Represents a reference to a guide, which could either be a Pendo Guide or User Guide Slug.
 */
interface GuideReference {
  /**
   * The unique identifier for the guide.
   * - For `PENDO`, this is the Pendo Guide ID.
   * - For `USER_GUIDE`, this is a relative path or slug used to construct the guide URL.
   */
  guideId: string;

  guideType: 'PENDO' | 'USER_GUIDE';
}

const GuideReferenceMap: Record<string, GuideReference | undefined> = {
  'guide-page-sales-billing': {
    guideId: '/sales-billing-dashboard-invoices-estimates-receipt',
    guideType: 'USER_GUIDE',
  },
  'guide-page-transactions': {
    guideId: '/working-with-transactions',
    guideType: 'USER_GUIDE',
  },
  'guide-settings-categories-tags': {
    guideId: '/using-categories',
    guideType: 'USER_GUIDE',
  },
  'guide-settings-transaction-rules': {
    guideId: '/using-transaction-rules',
    guideType: 'USER_GUIDE',
  },
  'guide-txn-allocation-credit-memo': { guideId: 't5F9W9Kms05OD69BsgylI8aSI7U', guideType: 'PENDO' },
  'guide-txn-allocation-credits': { guideId: 'FbmPmwYisq1Y-pnoFTHQBGRodG0', guideType: 'PENDO' },
  'guide-txn-allocation-invoice': { guideId: 'mdfxBUETuiLU8w-v3GWTJ_xwK1E', guideType: 'PENDO' },
  'guide-txn-allocation-payment-create': { guideId: 'O3qXG3Yrgj8aaEGwJmGD4SHFGYI', guideType: 'PENDO' },
  'guide-txn-allocation-payment-edit': { guideId: 'ypp2Sjmlvt5qeT4LI_qVmq5yiRU', guideType: 'PENDO' },
  'guide-txn-allocation-refund-create': { guideId: '08z1iPqZ8eUznqgYwhlpbd78CLs', guideType: 'PENDO' },
  'guide-txn-allocation-refund-edit': { guideId: '9ZwCazo_JqDCCvVZHDxcDpotYX0', guideType: 'PENDO' },

  //  "allocation-dialog-2": {guideId: "/recording-a-payment-on-an-invoice", guideType: 'USER_GUIDE'},
};

export default GuideReferenceMap;
